import React from 'react';
import { Page, Document, Text, StyleSheet, View } from '@react-pdf/renderer';
import { IBlock } from 'types';
import MarkdownPreview from '@uiw/react-markdown-preview';
import Table from 'components/blocks/Table';
import { cleanString } from 'utils';
import CustomChart from 'components/chart/CustomChart';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 30,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
  heading: {
    letterSpacing: 4,
    fontSize: 25,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: 24,
  },
  reportTitle: {
    color: '#61dafb',
    letterSpacing: 4,
    fontSize: 25,
    textTransform: 'uppercase',
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
});

export interface PDFDocumentInterface {
  title: string;
  blocks: any;
}

export default function PDFDocument(props: PDFDocumentInterface) {
  const { title, blocks } = props;
  return (
    <React.Fragment>
      <Document>
        <Page size='A4' style={styles.page}>
          <View style={styles.titleContainer}>
            <Text style={styles.reportTitle}>{title}</Text>
            {blocks?.map((block: Partial<IBlock>) => (
              <div key={block.id}>
                {block.results?.map((result) => (
                  <div style={styles.headingContainer}>
                    <Text>{block.title}</Text>
                    <Text>
                      Last Updated {new Date(result.updated as string).toLocaleDateString()} -{' '}
                      {new Date(result.updated as string).toLocaleTimeString()}
                    </Text>
                    {result.result_format === 'paragraph' && result.result_type === 'text' && <Text>{result?.content}</Text>}
                  </div>
                ))}
              </div>
            ))}
          </View>

          <CustomChart
            chartData={JSON.parse(
              '{"x": ["H34", "H34", "H34", "H35", "H35"], "y": ["11361400", "10451100", "7550900", "6809500", "5560800"], "x_label": "Variable_code", "y_label": "Value"}' as string
            )}
            chartType={'bar_chart'}
            title={title as string}
          />

          <Table
            data={
              cleanString(
                '{"Year": [2023, 2023, 2023, 2023, 2023], "Industry_aggregation_NZSIOC": ["Level 1", "Level 1", "Level 1", "Level 1", "Level 1"]}'
              ) as any
            }
          />

          <Text>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure expedita itaque corporis! Necessitatibus sit ullam voluptates corrupti,
            labore eligendi ipsam assumenda obcaecati ab laborum tenetur. Totam repellat a quasi earum? Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Iure expedita itaque corporis! Necessitatibus sit ullam voluptates corrupti, labore eligendi ipsam assumenda obcaecati
            ab laborum tenetur. Totam repellat a quasi earum? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure expedita itaque corporis!
            Necessitatibus sit ullam voluptates corrupti, labore eligendi ipsam assumenda obcaecati ab laborum tenetur. Totam repellat a quasi earum?
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure expedita itaque corporis! Necessitatibus sit ullam voluptates corrupti,
            labore eligendi ipsam assumenda obcaecati ab laborum tenetur. Totam repellat a quasi earum? Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Iure expedita itaque corporis! Necessitatibus sit ullam voluptates corrupti, labore eligendi ipsam assumenda obcaecati
            ab laborum tenetur. Totam repellat a quasi earum? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure expedita itaque corporis!
            Necessitatibus sit ullam voluptates corrupti, labore eligendi ipsam assumenda obcaecati ab laborum tenetur. Totam repellat a quasi earum?
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure expedita itaque corporis! Necessitatibus sit ullam voluptates corrupti,
            labore eligendi ipsam assumenda obcaecati ab laborum tenetur. Totam repellat a quasi earum? Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Iure expedita itaque corporis! Necessitatibus sit ullam voluptates corrupti, labore eligendi ipsam assumenda obcaecati
            ab laborum tenetur. Totam repellat a quasi earum? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure expedita itaque corporis!
            Necessitatibus sit ullam voluptates corrupti, labore eligendi ipsam assumenda obcaecati ab laborum tenetur. Totam repellat a quasi earum?
          </Text>

          <CustomChart
            chartData={JSON.parse(
              '{"x": ["H34", "H34", "H34", "H35", "H35"], "y": ["11361400", "10451100", "7550900", "6809500", "5560800"], "x_label": "Variable_code", "y_label": "Value"}' as string
            )}
            chartType={'bar_chart'}
            title={title as string}
          />
        </Page>
      </Document>
    </React.Fragment>
  );
}
